const Messages = {
    first_name_err: 'Please enter first name',
    last_name_err: 'Please enter last name',
    email_err: 'Please enter email',
    valid_email_err: 'Please enter valid email address',
    phone_number_err: 'Please enter phone number',
    message_err: 'Please enter message',
    valid_phone_number_err: 'Please enter valid phone number',
    dob_err: 'Please enter date of birth',
    gender_err: 'Please select gender',
    address_err: 'Please enter address',
    club_membership_id_err: 'Please enter club membership ID',
    password_err: 'Please enter password',
    confirm_password_err: 'Please confirm your password',
    payment_failed: 'Payment failed',
    payment_received: 'Your payment has been successfully confirmed. You will receive your email confirmation shortly.'
}
export default Messages;
export type MessageKeys = keyof typeof Messages;
